import { render, staticRenderFns } from "./scoketTest.vue?vue&type=template&id=9c195db2&"
import script from "./scoketTest.vue?vue&type=script&lang=js&"
export * from "./scoketTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports